import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const menuTemplate = document.createElement('template')
menuTemplate.innerHTML = `
    <wa-button
      size="small"
      appearance="plain"
      variant="neutral"
      aria-haspopup="true"
      aria-expanded="false"
      aria-controls="profile-dropdown"
      class="section-btn"
      with-caret
    >
      <slot name="buttonText"></slot>
    </wa-button>
`

class NavHeaderContextualNewMenuButton extends HTMLElement {
  private button: HTMLElement | null = null
  private isExpanded: boolean = false

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(menuTemplate.content.cloneNode(true))
  }

  connectedCallback() {
    this.button = this.shadowRoot?.querySelector('wa-button') || null

    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this))
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleClick.bind(this))
    }
  }

  private handleClick(event: Event) {
    event.preventDefault()
    event.stopPropagation()

    this.toggleMenu()
  }

  private toggleMenu() {
    this.isExpanded = !this.isExpanded

    // Update aria-expanded attribute
    if (this.button) {
      this.button.setAttribute('aria-expanded', this.isExpanded.toString())
    }

    // Toggle parent container appearance
    this.toggleParentContainerAppearance()

    // Find the transition container in the parent DOM
    const transitionContainer = this.findTransitionContainer()

    if (transitionContainer) {
      if (this.isExpanded) {
        this.showMenu(transitionContainer)
      } else {
        this.hideMenu(transitionContainer)
      }
    }
  }

  private findTransitionContainer(): HTMLElement | null {
    // Navigate up the DOM to find the contextual menu container
    let current = this.parentElement
    while (current) {
      // Look for the transition container with name="dropdown-fade"
      const transitionElement = current.querySelector('.sub-menu-item-container')
      if (
        transitionElement &&
        transitionElement.parentElement?.classList.contains('contextual-menu-dropdown')
      ) {
        return transitionElement as HTMLElement
      }
      current = current.parentElement
    }
    return null
  }

  private showMenu(container: HTMLElement) {
    // Add the show class to make it display: flex
    container.classList.add('show')

    // Force reflow
    void container.offsetHeight

    // Apply show animation by removing transform and opacity overrides
    container.style.opacity = '1'
    container.style.transform = 'translateY(0)'
  }

  private hideMenu(container: HTMLElement) {
    // Apply hide animation
    container.style.opacity = '0'
    container.style.transform = 'translateY(-10px)'

    // Hide the element after animation completes
    setTimeout(() => {
      if (!this.isExpanded) {
        container.classList.remove('show')
        // Reset inline styles
        container.style.opacity = ''
        container.style.transform = ''
      }
    }, 300)
  }

  private toggleParentContainerAppearance() {
    // Find the parent container with class 'contextual-menu-dropdown-separator'
    let current = this.parentElement
    while (current) {
      if (current.classList.contains('contextual-menu-dropdown-separator')) {
        if (this.isExpanded) {
          current.classList.add('active')
        } else {
          current.classList.remove('active')
        }
        break
      }
      current = current.parentElement
    }
  }
}

customElements.define('ts-navheader-contextual-new-menu-button', NavHeaderContextualNewMenuButton)
